import CustomerProfilePageTypeConfig from "./CustomerProfilePageTypeConfig";
import CustomerProfileOrdersPageService from "./CustomerProfileOrdersPageService";

export default class CustomerProfilePageService {
    public init(customerProfilePageTypeConfig: CustomerProfilePageTypeConfig): void {
        switch (customerProfilePageTypeConfig.customerProfilePage) {
            case "orders":
                this.initCustomerOrdersPage();
                break;
        }
    }

    private initCustomerOrdersPage(): void {
        const customerProfileOrdersPageService = new CustomerProfileOrdersPageService();

        customerProfileOrdersPageService.init();
    }
}
